import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { object, bool, func } from 'prop-types';
import styled from 'styled-components';
import { fontSize, fontFamily } from '../../../../constants/text';
import { colors } from '../../../../constants/colors';
import { isSavedLocation } from '../../../../core/util/account';
import { SAVE_LOCATION_ACCOUNT } from '../../../../sagas/account';
import SaveIcon from '../../../SaveIcon';
import withAuthentication from '../../../../core/login/withAuthentication';

const Root = styled.a`
  border: ${colors.borderLine} 1px solid;
  border-radius: 5px;
  padding: 8px 10px 10px;
  margin-right: 10px;
  cursor: pointer;
  white-space: nowrap;
`;

const SmallRoot = styled(Root)`
  border: none;
  padding: 10px 13px 0;

  &:last-child {
    padding: 10px 5px 0 13px;
  }
`;

const ActionName = styled.span`
  -webkit-font-smoothing: antialiased;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.squid};
  display: inline-block;
  vertical-align: middle;
  padding: 0 0 0 10px;
`;

const ActionIcon = styled.img`
  display: inline-block;
  vertical-align: middle;
  height: 16px;
  width: 16px;
`;

class SaveForLater extends PureComponent {
  static propTypes = {
    location: object,
    accountSummary: object,
    setSavedLocation: func,
    showText: bool,
    isLoggedIn: bool.isRequired,
  };

  getText = () => (this.isSavedLocation() ? 'Saved' : 'Save For Later');

  isSavedLocation = () => {
    const { location, accountSummary } = this.props;
    return isSavedLocation(location, accountSummary);
  };

  handleClick = () => {
    const {
      setSavedLocation,
      accountSummary,
      location: { id: locationId },
      isLoggedIn,
    } = this.props;

    const accountId = accountSummary && accountSummary.id;
    setSavedLocation({
      locationId,
      accountId,
      save: !this.isSavedLocation(),
      isLoggedIn,
    });
  };

  render() {
    const { showText, location } = this.props;
    const Container = showText ? Root : SmallRoot;
    return (
      <Container onClick={this.handleClick}>
        <SaveIcon location={location} />
        {showText && <ActionName>{this.getText()}</ActionName>}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  accountSummary: state.account.summary,
});

const mapDispatchToProps = dispatch => ({
  setSavedLocation: saveData => dispatch({ type: SAVE_LOCATION_ACCOUNT, ...saveData }),
});

export default withAuthentication(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SaveForLater)
);
